import { render, staticRenderFns } from "./EmployeeAttendDetails.vue?vue&type=template&id=2778d385&"
import script from "./EmployeeAttendDetails.vue?vue&type=script&lang=ts&"
export * from "./EmployeeAttendDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports